import TaskBulkOrderHeader from "./TaskBulkOrderHeader";
import { GetStatusIcon } from 'client/utils/IconsUtil'
import { useCallback, useEffect, useState } from "react";
import { getBulkOrderFleetAttachments, uploadBulkOrderAttachments } from "Store/Component/BulkOrder/BulkOrderAction";
import { useDispatch, useSelector } from "react-redux";
import { saveCancelFleetItem, setBulkOrderFleetHeader, setBulkOrderHeader, setCancelFleetItem } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import userProfileSelectors from 'redux/UserProfile/selectors'
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg"
import { commononUploadClick } from "utils";

const TaskBulkOrderHeaderContainer = (props?: any) => {
    const {
        item,
        purchaseOrderStepperData
    } = props
    const iconReturn = (status: any) => {
        return <img src={GetStatusIcon(status).icon} alt="statusIcon" className="statusIcon" />
    }
    const dispatch = useDispatch();
    const [uploadedList, setUploadedList] = useState<any>([]);
    const [list, setList] = useState<any>([])
    const [attachmentError, setAttachmentError] = useState<any>([]);
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comment: "",
        popupOutlinebtnOnclick: () => { },
        popupPrimarybtnOnclick: () => { }
      });

    const {
        itemAttachmentList,
        bulkOrderHeaderDetails,
        bulkOrderFleetDetails,
        userDetails,
        cancelFleetItem
    }: any = useSelector((state: any) => ({
        itemAttachmentList: state.BulkOrderReducer.attachmentList,
        bulkOrderHeaderDetails: state.PurchaseBulkOrderReducer.bulkOrderHeaderDetails,
        bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
        userDetails: userProfileSelectors.getUserDetails(state),
        cancelFleetItem: state.PurchaseBulkOrderReducer.cancelFleetItem
    }));

    useEffect(() => {
        if (item?.poAttachments)
            setList(item?.poAttachments ?? [])
        setUploadedList(item?.poAttachments ?? [])
    }, [])
    useEffect(() => {
        if (item?.fleetDetailId === itemAttachmentList?.requestIndex) {
            let bulkOrderFleetDetailsTemp = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
            bulkOrderFleetDetailsTemp?.map((item: any) => {
                item?.taskHeaderDetails?.map((taskItem?: any) => {
                    if (taskItem?.fleetDetailId === itemAttachmentList?.requestIndex) {
                        setUploadedList(itemAttachmentList?.list ?? []);
                        setList(itemAttachmentList?.list ?? []);
                        taskItem.poAttachments = itemAttachmentList?.list ?? [];
                        let payload = {
                            orderId: item?.orderId,
                            fleetDetailId: taskItem?.fleetDetailId,
                            attachments: itemAttachmentList?.list,
                            savedBy: userDetails?.emailId
                        }
                        dispatch(getBulkOrderFleetAttachments(payload))
                    }
                })
            })
            dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        }
    }, [itemAttachmentList?.list])

    const isUploaded = (name: string) => uploadedList.find((x: any) => (x.name || (x as any).fileName) === name);

    const onUploadClick = (fileList: Array<File>) => {
        let listItem = {
            fileList: fileList,
            uploadedList: uploadedList,
          }
        commononUploadClick(listItem, setAttachmentError, isUploaded, dispatch, uploadBulkOrderAttachments, item?.fleetDetailId, true);
    };

    const onRemoveClick = (index: number) => {
        const newArr = uploadedList.slice();
        newArr.splice(index, 1);
        let bulkOrderFleetDetailsTemp = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
        bulkOrderFleetDetailsTemp?.map((itemval: any) => {
            itemval?.taskHeaderDetails?.map((taskItem?: any) => {
                if (taskItem?.fleetDetailId === item?.fleetDetailId) {
                    setUploadedList(newArr ?? []);
                    setList(newArr ?? []);
                    taskItem.poAttachments = newArr ?? [];
                    let payload = {
                        orderId: itemval?.orderId,
                        fleetDetailId: taskItem?.fleetDetailId,
                        attachments: newArr,
                        savedBy: userDetails?.emailId
                    }
                    dispatch(getBulkOrderFleetAttachments(payload))
                }
            })

        })
        dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
        setAttachmentError("");
    };

    const handleItemCancelClick = (e?: any, fleetDetailId?: any) => {
        e.preventDefault();
        let decriptionTxt = (
          <>
            <p>Are you sure you want to cancel this item?</p>
          </>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "Confirmation",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          isCommentboxVisible: true,
          isCommentBoxRequire: true,
          isSingleConfirmationBtn: false,
          popupOutlinebtnOnclick: () => {
            setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          },
          popupPrimarybtnOnclick: (item: any,
            comment: string,
            actionby: string,
            value: any) => {
            const payload = {
                "fleetDetailId": fleetDetailId,
                "savedBy": userDetails?.emailId,
                "comments": comment
            }
            dispatch(saveCancelFleetItem(payload))
            setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          }
        });
      }

      const hideConfirmationDialog = useCallback(
        () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
        [Popupcontent]
      );

    useEffect(() => {        
        if (cancelFleetItem?.hasOwnProperty('fleetDetailId')) {
            const bulkOrderHeaderDetailsTemp: any = bulkOrderHeaderDetails ? JSON.parse(JSON.stringify(bulkOrderHeaderDetails)) : []
            let bulkOrderFleetDetailsTemp = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
            bulkOrderFleetDetailsTemp?.map((itemval: any) => {
                itemval?.taskHeaderDetails?.map((taskItem?: any) => {
                    if (taskItem?.fleetDetailId === cancelFleetItem?.fleetDetailId) {
                        taskItem.fleetStatus = cancelFleetItem?.fleetStatus
                        taskItem.itemStatus = cancelFleetItem?.itemStatus
                        taskItem.orderStatus = cancelFleetItem?.orderStatus
                        taskItem.cancelComments = cancelFleetItem?.cancelComments
                        bulkOrderHeaderDetailsTemp.orderStatus = cancelFleetItem.orderStatus
                    }
                })
                itemval?.fleetRequests?.map((taskItem?: any) => {
                    if (taskItem?.fleetItemId === cancelFleetItem?.fleetDetailId) {
                        taskItem.fleetStatus = cancelFleetItem?.fleetStatus
                        taskItem.itemStatus = cancelFleetItem?.itemStatus
                    }
                })
            })
            dispatch(setBulkOrderHeader(bulkOrderHeaderDetailsTemp));
            dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
            dispatch(setCancelFleetItem({}))
        }
    }, [cancelFleetItem])

    return (<TaskBulkOrderHeader
        item={item}
        iconReturn={iconReturn}
        list={list}
        uploadedList={uploadedList}
        setList={setList}
        onUploadClick={onUploadClick}
        attachmentError={attachmentError}
        setAttachmentError={setAttachmentError}
        onRemoveClick={onRemoveClick}
        handleItemCancelClick={handleItemCancelClick}
        purchaseOrderStepperData={purchaseOrderStepperData}
        Popupcontent = {Popupcontent}
        hideConfirmationDialog = {hideConfirmationDialog}
    />)
}

export default TaskBulkOrderHeaderContainer
